module.exports = __webpack_public_path__ + "assets/img/chart.97c1de50.png";